import { Tooltip, MenuItem, MenuItemProps } from '@mui/material';
import { useState, forwardRef, MouseEventHandler } from 'react';

interface NegotiationTermsFormQuoteModeItemProps extends MenuItemProps {
  disabled?: boolean;
  helperText?: string;
}

export const NegotiationTermsFormQuoteModeItem = forwardRef<HTMLLIElement, NegotiationTermsFormQuoteModeItemProps>(
  ({ children, helperText, ...props }, ref) => {
    const [open, setOpen] = useState(false);

    const handleClick: MouseEventHandler<HTMLLIElement> = (event) => {
      event.preventDefault();
      if (!props.disabled) props.onClick?.(event);
    };

    return (
      <Tooltip
        title={helperText}
        style={{ pointerEvents: 'auto' }}
        open={open}
        onMouseEnter={() => setOpen(true)}
        onMouseLeave={() => setOpen(false)}
      >
        <MenuItem ref={ref} {...props} onClick={handleClick}>
          <>{children}</>
        </MenuItem>
      </Tooltip>
    );
  },
);
